import { MAX_CHAT_WIDTH } from '../../constants';

export default theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
    },
    inputWrapper: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: -32,
            left: 0,
            right: 0,
            height: 32,
            background: `linear-gradient(to bottom, transparent, ${theme.palette.background.default})`,
            pointerEvents: 'none',
        },
    },
    inputContent: {
        width: '100%',
        maxWidth: MAX_CHAT_WIDTH,
        padding: theme.spacing(0, 2),
    },
    centerContainer: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(4),
    },
    emptyTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    emptyTitleRowCompact: {
        flexDirection: 'column',
        textAlign: 'center',
        gap: theme.spacing(3),
    },
    brandLockup: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    emptyTitle: {
        fontWeight: 700,
        textAlign: 'center',
        color: theme.palette.text.primary,
    },
    emptyInput: {
        width: '100%',
        maxWidth: MAX_CHAT_WIDTH,
    },
    suggestedPrompts: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
        width: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    suggestedPrompt: {
        textTransform: 'none',
        borderRadius: 6,
        ...theme.typography.body1,
        whiteSpace: 'nowrap',
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.divider,
        },
    },
    errorIcon: {
        fontSize: '3rem',
        color: theme.palette.error.main,
        marginBottom: theme.spacing(1),
    },
    escalatedBanner: {
        alignItems: 'center',
        margin: theme.spacing(1, 0),
        borderRadius: theme.spacing(1),
        '& .MuiAlert-action': {
            padding: 0,
        },
    },
    disclaimer: {
        display: 'block',
        textAlign: 'center',
        padding: theme.spacing(1, 2, 2),
        maxWidth: 600,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});
